import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import type { CalendarItemBundleData } from '../hooks/types'
import { getFnfInventoryMessage, getInventoryMessage, getInventoryMessageType } from '../hooks/utils'

function useCalendarItemPricing({
  bundleData,
  luxPlusEnabled,
  priceMode,
}: {
  bundleData: CalendarItemBundleData
  luxPlusEnabled: boolean
  priceMode: 'total' | 'perPerson'
}) {
  const intl = useIntl()

  return useMemo(() => {
    const regularPrice = priceMode === 'perPerson' ? bundleData.pricePerPerson : bundleData.totalPrice
    const memberPrice = priceMode === 'perPerson' ? bundleData.memberPricePerPerson : bundleData.memberTotalPrice
    const isMemberPrice = luxPlusEnabled && !!memberPrice
    const displayPrice = isMemberPrice && memberPrice ? memberPrice : regularPrice
    const originalRegularPrice = priceMode === 'perPerson' ? bundleData.originalPricePerPerson : bundleData.originalTotalPrice
    const originalMemberPrice = priceMode === 'perPerson' ? bundleData.originalMemberPricePerPerson : bundleData.originalMemberTotalPrice
    const wasPrice = isMemberPrice && originalMemberPrice ? originalMemberPrice : originalRegularPrice
    const shouldShowWasPrice = !!(bundleData.isFnfPriceApplied && wasPrice && wasPrice > displayPrice)

    return {
      regularPrice,
      memberPrice,
      isMemberPrice,
      displayPrice,
      wasPrice,
      shouldShowWasPrice,
      inventoryMessageType: getInventoryMessageType(bundleData.seatsLeft, bundleData.roomsLeft),
      inventoryMessage: getInventoryMessage(intl, bundleData.seatsLeft, bundleData.roomsLeft),
      fnfInventoryMessage: getFnfInventoryMessage(intl, bundleData.fnfSeatsLeft),
      specialOfferLabel: intl.formatMessage({
        id: 'QISSUEdraxBiVnazXHMb',
        defaultMessage: 'Special Offer',
        description: 'Highlight label shown when Maldives calendar pricing includes FnF pricing',
      }),
    }
  }, [bundleData, intl, luxPlusEnabled, priceMode])
}

export default useCalendarItemPricing
